import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mx-auto"
};
const _hoisted_2 = {
  class: "absolute top-0 left-0 right-0 h-50px bg-white border-bottom z-10 flex items-center px-20px"
};
const _hoisted_3 = {
  class: "w-200px flex items-center overflow-hidden"
};
const _hoisted_4 = ["title"];
const _hoisted_5 = {
  class: "flex-1 flex items-center justify-center h-full"
};
const _hoisted_6 = {
  class: "w-400px flex items-center justify-between h-full"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "text-16px font-bold whitespace-nowrap"
};
const _hoisted_9 = {
  class: "w-200px flex items-center justify-end gap-2"
};
const _hoisted_10 = {
  class: "mt-50px"
};
const _hoisted_11 = {
  key: 0,
  class: "mx-auto w-560px"
};
import { useTagsViewStore } from '@/store/modules/tagsView';
import { CommonStatusEnum } from '@/utils/constants';
import * as WorkflowApi from '@/api/ai/workflow';
import BasicInfo from './BasicInfo.vue';
import WorkflowDesign from './WorkflowDesign.vue';
import { ModelApi } from '@/api/ai/model/model';
import { AiModelTypeEnum } from '@/views/aip/utils/constants';
import { onMounted, provide, ref, unref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
import { useRoute, useRouter } from 'vue-router';
import Icon from '@/components/Icon/src/Icon.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const {
      delView
    } = useTagsViewStore();
    const route = useRoute();
    const message = useMessage();
    const basicInfoRef = ref();
    const workflowDesignRef = ref();
    const validateBasic = async () => {
      await basicInfoRef.value?.validate();
    };
    const validateWorkflow = async () => {
      await workflowDesignRef.value?.validate();
    };
    const currentStep = ref(-1);
    const steps = [{
      title: '基本信息',
      validator: validateBasic
    }, {
      title: '工作流设计',
      validator: validateWorkflow
    }];
    const formData = ref({
      id: undefined,
      name: '',
      code: '',
      remark: '',
      graph: '',
      status: CommonStatusEnum.ENABLE
    });
    const llmProvider = ref([]);
    const workflowData = ref({});
    provide('workflowData', workflowData);
    /** 初始化数据 */
    const actionType = route.params.type;
    const initData = async () => {
      // 编辑情况下，需要加载工作流配置
      if (actionType === 'update') {
        const workflowId = route.params.id;
        formData.value = await WorkflowApi.getWorkflow(workflowId);
        workflowData.value = JSON.parse(formData.value.graph);
      }
      // 加载模型列表
      const models = await ModelApi.getModelSimpleList(AiModelTypeEnum.CHAT);
      llmProvider.value = {
        llm: () => models.map(({
          id,
          name
        }) => ({
          value: id,
          label: name
        })),
        knowledge: () => [],
        internal: () => []
      };
      // TODO @lesan：知识库（可以看下 knowledge）
      // TODO @lesan：搜索引擎（这个之前有个 pr 搞了，，，可能来接下）
      // 设置当前步骤
      currentStep.value = 0;
    };
    /** 校验所有步骤数据是否完整 */
    const validateAllSteps = async () => {
      try {
        // 基本信息校验
        try {
          await validateBasic();
        } catch (error) {
          currentStep.value = 0;
          throw new Error('请完善基本信息');
        }
        // 工作流设计校验
        try {
          await validateWorkflow();
        } catch (error) {
          currentStep.value = 1;
          throw new Error('请完善工作流信息');
        }
        return true;
      } catch (error) {
        throw error;
      }
    };
    /** 保存操作 */
    const handleSave = async () => {
      try {
        // 保存前校验所有步骤的数据
        await validateAllSteps();
        // 更新表单数据
        const data = {
          ...formData.value,
          graph: JSON.stringify(workflowData.value)
        };
        if (actionType === 'update') {
          await WorkflowApi.updateWorkflow(data);
        } else {
          await WorkflowApi.createWorkflow(data);
        }
        // 保存成功，提示并跳转到列表页
        message.success('保存成功');
        delView(unref(router.currentRoute));
        await router.push({
          name: 'AiWorkflow'
        });
      } catch (error) {
        console.error('保存失败:', error);
        message.warning(error.message || '请完善所有步骤的必填信息');
      }
    };
    /** 步骤切换处理 */
    const handleStepClick = async index => {
      try {
        if (index !== 0) {
          await validateBasic();
        }
        if (index !== 1) {
          await validateWorkflow();
        }
        // 切换步骤
        currentStep.value = index;
      } catch (error) {
        console.error('步骤切换失败:', error);
        message.warning('请先完善当前步骤必填信息');
      }
    };
    /** 返回列表页 */
    const handleBack = () => {
      // 先删除当前页签
      delView(unref(router.currentRoute));
      // 跳转到列表页
      router.push({
        name: 'AiWorkflow'
      });
    };
    /** 初始化 */
    onMounted(async () => {
      await initData();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_ContentWrap = _resolveComponent("ContentWrap");
      return _openBlock(), _createBlock(_component_ContentWrap, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(Icon, {
          icon: "ep:arrow-left",
          class: "cursor-pointer flex-shrink-0",
          onClick: handleBack
        }), _createElementVNode("span", {
          class: "ml-10px text-16px truncate",
          title: formData.value.name || '创建流程'
        }, _toDisplayString(formData.value.name || '创建流程'), 9, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step, index) => {
          return _createElementVNode("div", {
            key: index,
            class: _normalizeClass(["flex items-center cursor-pointer mx-15px relative h-full", [currentStep.value === index ? 'text-[#3473ff] border-[#3473ff] border-b-2 border-b-solid' : 'text-gray-500']]),
            onClick: $event => handleStepClick(index)
          }, [_createElementVNode("div", {
            class: _normalizeClass(["w-28px h-28px rounded-full flex items-center justify-center mr-8px border-2 border-solid text-15px", [currentStep.value === index ? 'bg-[#3473ff] text-white border-[#3473ff]' : 'border-gray-300 bg-white text-gray-500']])
          }, _toDisplayString(index + 1), 3), _createElementVNode("span", _hoisted_8, _toDisplayString(step.title), 1)], 10, _hoisted_7);
        }), 64))])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSave
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode(" 保 存 ")])),
          _: 1
        })])]), _createElementVNode("div", _hoisted_10, [currentStep.value === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(BasicInfo, {
          modelValue: formData.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value = $event),
          ref_key: "basicInfoRef",
          ref: basicInfoRef
        }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), currentStep.value === 1 ? (_openBlock(), _createBlock(WorkflowDesign, {
          key: 1,
          modelValue: formData.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value = $event),
          provider: llmProvider.value,
          ref_key: "workflowDesignRef",
          ref: workflowDesignRef
        }, null, 8, ["modelValue", "provider"])) : _createCommentVNode("", true)])])]),
        _: 1
      });
    };
  }
});